(() => {
  const HERO_SECTION_NAMES = ['Hero Banner', 'Hero Banner Slide 2'];

  const getHeroSlides = () => {
    const main = document.getElementById('MainContent');
    if (!main) return [];

    // Explicit pairs only. This keeps each page's intended first and second
    // hero sections together without accidentally wrapping other sections.
    const slidePairs = [
      ['__section_WMLCRf', '__section_hero_slide_2'],
      ['__hero_7CAtDj', '__hero_eTJ7tw'],
    ];

    for (const [firstSuffix, secondSuffix] of slidePairs) {
      const first = main.querySelector(`[id$="${firstSuffix}"]`);
      const second = main.querySelector(`[id$="${secondSuffix}"]`);
      if (first && second) return [first, second];
    }

    const directSections = [...main.children].filter((el) =>
      el?.classList?.contains('shopify-section') || el?.classList?.contains('ruben-hero-slideshow')
    );

    const slides = [];
    directSections.forEach((el) => {
      if (el.classList?.contains('ruben-hero-slideshow')) {
        slides.push(...el.querySelectorAll(':scope > .ruben-hero-slide'));
        return;
      }

      const schemaName = el.querySelector('shopify-editor-section')?.getAttribute('data-section-name') || '';
      const id = el.id || '';
      const likelyHero =
        HERO_SECTION_NAMES.some((name) => schemaName.includes(name)) ||
        id.endsWith('__section_WMLCRf') ||
        id.endsWith('__section_hero_slide_2') ||
        id.endsWith('__hero_slide_2');

      if (likelyHero) slides.push(el);
    });

    return slides.slice(0, 2);
  };

  const unwrapExistingStage = () => {
    const stage = document.querySelector('.ruben-hero-slideshow');
    if (!stage) return;

    const parent = stage.parentNode;
    const slides = [...stage.querySelectorAll(':scope > .ruben-hero-slide')];
    slides.forEach((slide) => {
      slide.classList.remove('ruben-hero-slide', 'is-active');
      slide.removeAttribute('data-ruben-hero-slide');
      slide.removeAttribute('aria-hidden');
      slide.style.position = '';
      slide.style.inset = '';
      slide.style.width = '';
      slide.style.minHeight = '';
      parent.insertBefore(slide, stage);
    });
    stage.remove();
  };

  const init = () => {
    unwrapExistingStage();

    const slides = getHeroSlides();
    if (slides.length < 2) return;

    const stage = document.createElement('div');
    stage.className = 'ruben-hero-slideshow';
    stage.setAttribute('aria-label', 'Hero banner slideshow');

    slides[0].parentNode.insertBefore(stage, slides[0]);
    slides.forEach((slide, index) => {
      slide.classList.add('ruben-hero-slide');
      slide.dataset.rubenHeroSlide = String(index);
      slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      slide.style.position = 'absolute';
      slide.style.inset = '0';
      slide.style.width = '100%';
      slide.style.minHeight = '100svh';
      if (index === 0) slide.classList.add('is-active');
      stage.appendChild(slide);
    });

    const controls = document.createElement('div');
    controls.className = 'ruben-hero-slideshow__controls';
    controls.setAttribute('aria-label', 'Hero slides');

    const buttons = slides.map((_, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ruben-hero-slideshow__dot';
      button.setAttribute('aria-label', `Show hero slide ${index + 1}`);
      button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      button.addEventListener('click', () => {
        show(index);
        restart();
      });
      controls.appendChild(button);
      return button;
    });

    stage.appendChild(controls);

    let current = 0;
    let timer = null;

    function show(next) {
      current = next;
      slides.forEach((slide, index) => {
        const active = index === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        buttons[index].setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function start() {
      if (window.Shopify?.designMode) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => show((current + 1) % slides.length), 6500);
    }

    function restart() {
      if (timer) window.clearInterval(timer);
      start();
    }

    stage.addEventListener('mouseenter', () => {
      if (timer) window.clearInterval(timer);
    });
    stage.addEventListener('mouseleave', restart);

    start();
  };

  const scheduleInit = () => window.requestAnimationFrame(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  // Shopify Theme Editor can reload one section at a time. Rebuild the wrapper so
  // the live preview and the published storefront always use the current section
  // settings from Edit theme instead of stale wrapped DOM.
  document.addEventListener('shopify:section:load', scheduleInit);
  document.addEventListener('shopify:section:unload', scheduleInit);
  document.addEventListener('shopify:section:select', (event) => {
    const selected = event.target;
    if (!selected?.classList?.contains('ruben-hero-slide')) return;
    const slides = [...document.querySelectorAll('.ruben-hero-slideshow > .ruben-hero-slide')];
    const index = slides.indexOf(selected);
    const buttons = [...document.querySelectorAll('.ruben-hero-slideshow__dot')];
    if (index < 0) return;
    slides.forEach((slide, i) => {
      const active = i === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      buttons[i]?.setAttribute('aria-current', active ? 'true' : 'false');
    });
  });
})();
